import axios from '../../../service/axios';

const base = '/iam-sales/pit-agreements';

export class PitAgreementService {
  static adminList(lazyLoadEvent: string): Promise<any> {
    return axios.get(`${base}/admin-list`, {params: {lazyLoadEvent}})
      .then(response => response.data);
  }

  static list(): Promise<any> {
    return axios.get(`${base}/list`).then(response => response.data);
  }

  static detail(id: string): Promise<any> {
    return axios.get(`${base}/${id}/detail`).then(response => response.data);
  }

  static pdf(id: string): Promise<any> {
    return axios.get(`${base}/${id}/pdf`).then(response => response.data);
  }

  static prepare(id: string): Promise<any> {
    return axios.put(`${base}/${id}/prepare-sign`).then(response => response.data);
  }

  static complete(id: string, signingToken: string, xmlSignedBase64: string): Promise<any> {
    return axios.post(`${base}/${id}/complete-sign`, {signingToken, xmlSignedBase64}).then(response => response.data);
  }

  static fail(id: string, signingToken: string): Promise<any> {
    return axios.post(`${base}/${id}/fail-sign`, {signingToken}).then(response => response.data);
  }
}
